import React from "react";
import CompanyBirgjamatPage from "@components/Pages/CompanyBirgjamatPage/CompanyBirgjamatPage";

export default function Software() {
    return <CompanyBirgjamatPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../../locales/${locale}.json`)).default,
        },
    };
}
